<template>
  <v-app>
  <v-container>
    <v-row
      justify="center"
      no-gutters
    >
    <h2 
    class="projTitle"
    data-aos="fade-up"
    data-aos-duration="1500"
    >{{title}}</h2>

      <v-col lg="10" md="10" sm="10" class="main-section"
      data-aos="fade-right"
        data-aos-duration="1500">          
          <v-carousel 
        :cycle="true"
        :interval=6000
        class="mx-auto"
        >
        <v-carousel-item
          v-for="(image,i) in images"
          :key="i"
          :src="image.src"
        ></v-carousel-item>
      </v-carousel>      
      <p class="work-desc">
        I host various WordPress websites designed to meet the needs of small businesses wanting to stand out, attract customers and keep an up-to-date presence online.
      </p>
      <p class="work-desc">
        I leverage many different kinds of extentions to help people do business such as social, commerce, galleries, analytics etc.
      </p>

      <v-btn disabled class="visit" color="primary">Various websites</v-btn>
        
      </v-col>
      <v-col lg="2" md="2" sm="2" cols="auto"
      data-aos="fade-left"
        data-aos-duration="1500">
        
<v-card
          v-for="tech in technologies" :key="tech.name"
        class="tech"
        >
          <v-card-text >
            <div>{{ tech.name }}</div>
          </v-card-text>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
  </v-app>
</template>

<script>
  export default {
    name: 'DNAProject',
    data () {
      return {
        images: [
          {
            src: require('../assets/projects/steedmunds750x750.jpg'),
          },
          {
            src: require('../assets/projects/catherine_750x750.jpg'),
          },
          {
            src: require('../assets/projects/kingswinford_750x750.jpg'),
          },
          {
            src: require('../assets/projects/ptp1.jpg'),
          },
          {
            src: require('../assets/projects/ptp2.jpg'),
          },
          {
            src: require('../assets/projects/ptp3.jpg'),
          },
          {
            src: require('../assets/projects/bmna.jpg'),
          },
        ],
        technologies: [
        { name: "CMS" },
        { name: "Blogs" },
        { name: "eCommerce" },
        { name: "Galleries" },
        { name: "Analytics" },
        { name: "Marketing" }
    ],
    title: "WordPress (Various sites)"
      }
    },
  }
</script>
<style scoped>
.container{
  width: 100%;
  margin-bottom: 20px;
}
.text--secondary{
      text-align: left;      
}
.main-section{
  margin-bottom: 15px;
}
.text--desc{margin-bottom: 10px;}
.right{margin-left: 20px;}
.tech{
  margin-bottom: 20px;
  border-radius: 0px 50px 50px 0px!important;
  background-color: #3782d2!important;
  color: #fff!important;
}
.v-card__text{
  color: #fff!important;
  padding: 5px;
  }
.v-window-item{max-width: 100%;}
.work-desc{
  font-size: 1em;
  text-align: left;
}
h2{
  margin-top: 20px;
  margin-bottom: 20px;
  width: 100%;
}
  @media only screen and (max-width: 600px) {
  .tech{
  border-radius: 50px 50px 50px 50px!important;
  width: max-content;
  display: inline-block;
  margin: 5px;
  padding: 5px;
  }
  .columns{
    margin-top: 20px;
  }
}  
.visit{
    width: 100%;
  }
  .projTitle{
    margin-left: auto;
    margin-right: auto;
  }
  .v-application{
  margin-top: 0!important;
  }
  .v-application{
  margin-top: 0!important;
  }
  .row{
    border: solid 5px rgba(55,130,210, 0.2);
    border-radius: 25px;
    padding: 30px;
  }
</style>

